import React from 'react'
import { defineMessages } from 'react-intl'
import { GetApp } from 'components/GetApp/index.js'
import { TrackCaloriesCTA } from 'pages/TrackCalories/Cta/index.js'

const messages = defineMessages({
  description: {
    id: 'TrackCaloriesGetApp.description',
    defaultMessage: 'Track Calories in Seconds'
  }
})

export function TrackCaloriesGetApp () {
  return (
    <GetApp
      descriptionMessage={messages.description}
      ctaComponent={
        <TrackCaloriesCTA
          isCentered
        />
      }
    />
  )
}
